import React from 'react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import { AppUI } from '@seedlang/state';
import { isPresent, isBlank } from '@seedlang/utils';
import Button from 'components/button/button';
import Alert from 'components/alert';
import Text from 'components/text';
import PageTitle from 'components/common/page_title';
import Stack from 'components/layout/stack';
import styled from '@emotion/styled';
import SeedlangOnly from 'utils/seedlang_only';
import { SettingsBillingWrapper } from '@seedlang/hoc';

const StyledButton = styled(Button)`
  align-self: flex-start;
`;

@observer
class SettingsPassword extends React.Component {
  constructor(props) {
    super(props);
    this.newPassword1Ref = React.createRef();
    this.newPassword2Ref = React.createRef();
    this.oldPasswordRef = React.createRef();
  }

  @observable respSuccess = false;
  @observable respFailure = false;
  @observable oldPassword = '';
  @observable newPassword1 = '';
  @observable newPassword2 = '';
  @observable message = '';

  @computed get disableSubmit() {
    return isBlank(this.oldPassword) || this.newPassword1 !== this.newPassword2 || this.newPassword1.length < 8;
  }

  onChangePassword() {
    AppUI.authUserStore.update({
      failureCallback: this.afterChangePassword,
      data: {
        old_password: this.oldPassword,
        password: this.newPassword1,
        password_confirmation: this.newPassword2,
      },
    }, this.afterChangePassword);
    this.reset();
  }
  afterChangePassword = (resp) => {
    if (resp.success) {
      this.respSuccess = true;
    } else {
      this.message = resp.userMessage;
      this.respFailure = true;
    }
  }
  reset = () => {
    this.oldPassword = '';
    this.newPassword1 = '';
    this.newPassword2 = '';
    this.respSuccess = false;
    this.respFailure = false;
    this.message = '';
  }

  @computed get infoMessage() {
    if (!this.props.otherSitesWarning) return '';
    return `You are also changing your password on ${this.props.otherSitesWarning}.`;
  }

  render() {
    return (
      <Stack gap='md' alignItems='stretch'>
        <SeedlangOnly>
          <PageTitle>Change Password</PageTitle>
        </SeedlangOnly>
        <Text heading='3'>
          Change Password
        </Text>
        {
          this.respSuccess &&
            <Alert
              textAlign='center'
            >
              Password was changed.
            </Alert>
        }
        {
          this.respFailure &&
            <Alert
              textAlign='center'
            >
              {isPresent(this.message) ? this.message : 'There was a problem changing your password.'}
            </Alert>
        }

        <div>
          <label className='form-label'>
            Old Password
          </label>
          <input
            ref={this.oldPasswordRef}
            type='password'
            value={this.oldPassword}
            onChange={e => this.oldPassword = e.target.value}
          />
        </div>

        <div>
          <label className='form-label'>
            New Password
          </label>
          <input
            ref={this.newPassword1Ref}
            type='password'
            value={this.newPassword1}
            onChange={e => this.newPassword1 = e.target.value}
          />
        </div>

        <div>
          <label className='form-label'>
            Confirm New Password
          </label>
          <input
            ref={this.newPassword2Ref}
            type='password'
            value={this.newPassword2}
            onChange={e => this.newPassword2 = e.target.value}
          />
        </div>

        {this.infoMessage && (
          <Stack inline gap='xs' alignItems='center'>
            <i className='fa fa-info-circle' />
            {this.infoMessage}
          </Stack>
        )}

        <StyledButton
          disabled={this.disableSubmit}
          onClick={() => this.onChangePassword()}
          background={AppUI.siteIsSeedlang ? null : AppUI.site.accentColor}
        >
          Change Password
        </StyledButton>
      </Stack>
    );
  }
}

export default SettingsBillingWrapper(SettingsPassword);
